import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { segmentKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useSegments = (params) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(markUrl('segments/list/'), {
            ...additional,
            params
        }),
        queryKey: segmentKeys.list(params),
        staleTime: 30_000
    });
};
export default useSegments;
